import CTA from "@/elements/CTA";
import {getGtagPageName} from "@/utils/getGtagPageName";
import * as gtag from "@/utils/gtag.client";
import {buildViaMichelinUrl} from "@/utils/viaMichelinUrlBuilder";

interface PushMailCtaProps {
  title?: string;
  url?: string;
  target?: string;
  buttonColor?: string;
}

// The button of the two « push mail » blocks, to ViaMichelin: the link carries the tracking, and a click is told to the data layer
const PushMailCta = ({title, url, target, buttonColor}: PushMailCtaProps) => {
  if (!title) return null;
  return (
    <CTA
      buttonStyles={{alignSelf: "start"}}
      variant="viaMichelin"
      size="medium"
      buttonColor={buttonColor}
      type="primary"
      to={url ? buildViaMichelinUrl({baseUrl: url}) : url}
      target={target}
      onClick={() => {
        gtag.event({
          event: "redirection_vm",
          action: "click",
          page_name: getGtagPageName(window.location.pathname),
        });
      }}
    >
      {title}
    </CTA>
  );
};

export default PushMailCta;
